import { render, staticRenderFns } from "./detialDesign.vue?vue&type=template&id=705f5b44&"
import script from "./detialDesign.vue?vue&type=script&lang=js&"
export * from "./detialDesign.vue?vue&type=script&lang=js&"
import style0 from "./detialDesign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports